export default "__VITE_ASSET__Dxjs$vC6__"